import { render, staticRenderFns } from "./ActTab.vue?vue&type=template&id=7f9f4efc"
import script from "./ActTab.vue?vue&type=script&lang=js"
export * from "./ActTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports